import { ApiFragment } from '@/types/workbench';

/**
 * Gets the effective end time for a fragment, using PeakDataSegment fallback when timeEnd is null
 * @param fragment - The fragment with potentially null timeEnd/timeEndAdjusted
 * @param lastSegmentEndTimeMs - Optional last segment end time in milliseconds for fallback
 * @returns The effective end time in centiseconds (timeEnd format)
 */
export function getFragmentEndTime(fragment: ApiFragment, lastSegmentEndTimeMs?: number): number {
  // If timeEnd exists, use it
  if (fragment.timeEnd !== null) {
    return fragment.timeEnd;
  }

  // If lastSegmentEndTimeMs is available, use it as fallback
  if (lastSegmentEndTimeMs && lastSegmentEndTimeMs > 0) {
    return Math.trunc(lastSegmentEndTimeMs / 10);
  }

  // Fallback: use timeStart + 10 seconds if no other option
  return fragment.timeStart + 1000;
}

/**
 * Gets the effective adjusted end time for a fragment, using PeakDataSegment fallback when timeEndAdjusted is null
 * @param fragment - The fragment with potentially null timeEnd/timeEndAdjusted
 * @param lastSegmentEndTimeMs - Optional last segment end time in milliseconds for fallback
 * @returns The effective adjusted end time in centiseconds (timeEndAdjusted format)
 */
export function getFragmentEndTimeAdjusted(
  fragment: ApiFragment,
  lastSegmentEndTimeMs?: number,
): number {
  // If timeEndAdjusted exists, use it
  if (fragment.timeEndAdjusted !== null) {
    return fragment.timeEndAdjusted;
  }

  // If lastSegmentEndTimeMs is available, use it as fallback
  if (lastSegmentEndTimeMs && lastSegmentEndTimeMs > 0) {
    return Math.trunc(lastSegmentEndTimeMs / 10);
  }

  // Fallback: use timeStartAdjusted + 10 seconds if no other option
  return fragment.timeStartAdjusted + 1000;
}
